import { db } from "@db";
import { createSearchStore } from "@fetch/searchStore";
import type { BlastResult, BlastSearch } from "./types";

export const useBlastStore = createSearchStore<BlastSearch, BlastResult>({
  searchesTable: () => db.blastSearches,
  resultsTable: () => db.blastResults,
});
